import { render } from "./tags.vue?vue&type=template&id=4a0db0ca"
import script from "./tags.vue?vue&type=script&lang=js"
export * from "./tags.vue?vue&type=script&lang=js"

import "./tags.vue?vue&type=style&index=0&id=4a0db0ca&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__